import isLoggedIn from "./isLoggedIn";
import isAdmin from "./isAdmin";
import favorites from "./favorites";
import errorMessage from "./errorMessage";
import instagramAccounts from "./instagramAccounts";

export default {
  isLoggedIn,
  isAdmin,
  favorites,
  errorMessage,
  instagramAccounts,
};
